<template>
  <div class="related-articles">
    <Intro :blok="makeIntroData()" />
    <CardGrid :blok="articles" />
  </div>
</template>

<script lang="ts" setup>
import { IntroBlokProps, CardGridBlokProps } from '@/types';

// Props
defineProps<{
  articles: CardGridBlokProps;
}>();

const makeIntroData = (): IntroBlokProps => ({
  container_size: 'medium',
  text: [
    {
      eyebrow: 'Read More',
      heading: [
        {
          heading_style: 'text-2',
          heading_text: {
            content: [
              {
                content: [
                  {
                    text: 'Related ',
                    type: 'text',
                  },
                  {
                    marks: [
                      {
                        attrs: {
                          class: 'drawing-line-1',
                        },
                        type: 'styled',
                      },
                    ],
                    text: 'articles',
                    type: 'text',
                  },
                ],
                type: 'paragraph',
              },
            ],
            type: 'doc',
          },
          heading_type: 'h3',
        },
      ],
    },
  ],
});
</script>
